import {
  NotificationsFormValues,
  OrderArrivedFormFields,
  OrderShippedFormFields,
} from '~/types/EmailNotifications';
import { ActionKeys } from './constants';

export function fetchNotifications() {
  return <const>{
    type: ActionKeys.FETCH_NOTIFICATIONS,
  };
}

export function fetchNotificationsSuccess(payload: NotificationsFormValues) {
  return <const>{
    payload,
    type: ActionKeys.FETCH_NOTIFICATIONS_SUCCESS,
  };
}

export function fetchNotificationsError(errorMessage) {
  return <const>{
    type: ActionKeys.FETCH_NOTIFICATIONS_ERROR,
    payload: {
      errorMessage,
    },
  };
}

export function updateOrderShippedEmailSettings(orderShippedFormFields: OrderShippedFormFields) {
  return <const>{
    type: ActionKeys.UPDATE_ORDER_SHIPPED_EMAIL_SETTINGS,
    payload: {
      orderShippedFormFields,
    },
  };
}

export function updateOrderShippedEmailSettingsSuccess(
  orderShippedFormFields: OrderShippedFormFields,
) {
  return <const>{
    type: ActionKeys.UPDATE_ORDER_SHIPPED_EMAIL_SETTINGS_SUCCESS,
    payload: {
      orderShippedFormFields,
    },
  };
}

export function updateOrderShippedEmailSettingsError(errorData) {
  return <const>{
    type: ActionKeys.UPDATE_ORDER_SHIPPED_EMAIL_SETTINGS_ERROR,
    payload: {
      errorData,
    },
  };
}

export function updateOrderArrivedEmailSettings(orderArrivedFormFields: OrderArrivedFormFields) {
  return <const>{
    type: ActionKeys.UPDATE_ORDER_ARRIVED_EMAIL_SETTINGS,
    payload: {
      orderArrivedFormFields,
    },
  };
}

export function updateOrderArrivedEmailSettingsSuccess(
  orderArrivedFormFields: OrderArrivedFormFields,
) {
  return <const>{
    type: ActionKeys.UPDATE_ORDER_ARRIVED_EMAIL_SETTINGS_SUCCESS,
    payload: {
      orderArrivedFormFields,
    },
  };
}

export function updateOrderArrivedEmailSettingsError(errorData) {
  return <const>{
    type: ActionKeys.UPDATE_ORDER_ARRIVED_EMAIL_SETTINGS_ERROR,
    payload: {
      errorData,
    },
  };
}

export function sendSampleEmail(notificationType: string) {
  return <const>{
    notificationType,
    type: ActionKeys.SEND_SAMPLE_EMAIL,
  };
}

export function sendSampleEmailSuccess(notificationType: string) {
  return <const>{
    notificationType,
    type: ActionKeys.SEND_SAMPLE_EMAIL_SUCCESS,
  };
}

export function sendSampleEmailError(notificationType: string) {
  return <const>{
    notificationType,
    type: ActionKeys.SEND_SAMPLE_EMAIL_ERROR,
  };
}

export function clearSampleEmailErrors() {
  return <const>{
    type: ActionKeys.CLEAR_SAMPLE_EMAIL_ERRORS,
  };
}

export type NotificationsActions =
  | ReturnType<typeof fetchNotifications>
  | ReturnType<typeof fetchNotificationsSuccess>
  | ReturnType<typeof fetchNotificationsError>
  | ReturnType<typeof sendSampleEmail>
  | ReturnType<typeof sendSampleEmailSuccess>
  | ReturnType<typeof sendSampleEmailError>
  | ReturnType<typeof clearSampleEmailErrors>
  | ReturnType<typeof updateOrderShippedEmailSettings>
  | ReturnType<typeof updateOrderShippedEmailSettingsSuccess>
  | ReturnType<typeof updateOrderShippedEmailSettingsError>
  | ReturnType<typeof updateOrderArrivedEmailSettings>
  | ReturnType<typeof updateOrderArrivedEmailSettingsSuccess>
  | ReturnType<typeof updateOrderArrivedEmailSettingsError>;
